<template>
	<div class="members-rewards">
		<h3>Member Search</h3>

		<div class="members">
			<input name="search" placeholder="Search Member (Press Enter to search)" v-model="search" v-on:keyup.enter="getMember" autocomplete="off" />
			<div class="add-button" @click="getMember()">Search</div>

			<h3 v-if="noResult">Member not found!</h3>

			<h3 v-if="members.length > 0">Search Result</h3>
			<div v-if="members.length > 0" class="members-list">
				<div>
					<p class="header">Member ID</p>
				</div>

				<div>
					<p class="header">Name</p>
				</div>

				<div>
					<p class="header">Phone</p>
				</div>
			</div>

			<div v-if="members.length > 0" class="rewards">
				<div v-for="(item, index) of members" v-bind:key="index" class="members-list">
					<div>{{ item.card_number }}</div>
					<div>{{ item.name }}</div>
					<div>{{ item.mobile_phone }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'settings',

	data: function() {
		return {
			search: null,
			memberInfo: null,
			members: [],
			rewards: [],
			selectedGifts: [],
			tempPoints: 0,
			isLoading: false,
			noResult: false,

			branchName: null,
			ranchPhoneNumber: null
		}
	},

	watch: {},

	mounted: async function() {},

	methods: {
		// Get brach info
		getBranchInfo: async function() {
			// Get data from info api
			const apiInfo = await this.$api.branchInfo()

			if (apiInfo !== undefined) {
				// Assign data
				let data = apiInfo.data['static-values'].configs.shops.entity

				// Assign branch name. Branch name is required
				this.branchName = data.name

				if (data.mobile_phone) {
					this.branchPhoneNumber = data.mobile_phone
				} else {
					this.branchPhoneNumber = this.$config.brandPhone
				}
			} else {
				// If error, set default values
				this.branchName = this.$config.branchName
				this.branchPhoneNumber = this.$config.brandPhone
			}
		},

		submit: async function() {
			if (this.selectedGifts.length > 0) {
				this.isLoading = true

				let data = {
					customer: this.memberInfo._id,
					selectedProducts: []
				}

				this.selectedGifts.map(product => {
					data.selectedProducts.push(product.reward._id)
				})

				let checkout = await this.$api.rewardCheckout({ data })

				// Show messages
				if (checkout && checkout.data.ok == 1) {
					this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Reward has been saved!', showConfirmButton: false, timer: 1500 })

					// Reset default
					this.memberID = null
					this.clean()
				} else {
					this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Something is wrong!', showConfirmButton: true, timer: 3500 })
				}

				this.isLoading = false
			}
		},

		// To remove rewards
		removeRewards: async function(key, points) {
			this.tempPoints += points

			this.selectedGifts.splice(key, 1)
		},

		// To add rewards
		addRewards: async function(item) {
			this.tempPoints -= item.points
			this.selectedGifts.push(item)
		},

		// Clean states
		clean: function() {
			this.memberInfo = null
			this.members = []
			this.rewards = []
			this.selectedGifts = []
			this.tempPoints = 0
		},

		print: function() {
			this.$printd.print(document.getElementById('printing'), [this.cssText])
		},

		// Reset server setting
		getMember: async function() {
			this.clean()

			// Make sure member id isn't blank
			if (this.search == null) {
				this.$swal.fire('Error!', 'Member ID cannot be blanked', 'error')

				return
			}

			// Set data
			let data = {
				search: this.search
			}

			const apiSearchMember = await this.$api.searchMember({ data })

			if (!apiSearchMember || !apiSearchMember.data) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Invalid Search'
				})

				return
			} else {
				this.members = apiSearchMember.data.list

				if (apiSearchMember.data.total == 0) {
					this.noResult = true
				} else {
					this.noResult = false
				}
			}
		}
	}
}
</script>

<style scoped>
.members {
	font-size: 13px;
	font-family: 'poppinssemibold';
	color: #000;
}

h3 {
	margin: 20px;
}

.members input {
	border-radius: 5px;
	height: 40px;
	width: 350px;
	padding: 0 10px;
	font-size: 13px;
	margin-bottom: 20px;
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	font-family: 'poppinssemibold';
	border: 1px solid #d5e3f5;
	background-color: #fff;
}

.memberInfo {
	width: 500px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	margin: 20px auto;
}

.header {
	font-size: 13px;
	font-family: 'poppinsbold';
	color: #aaa;
}

.members-list {
	width: 800px;
	display: grid;
	text-align: left;
	grid-template-columns: 1fr 1fr 1fr;
	margin: 10px auto 10px;
	padding: 10px;
	border-bottom: 1px solid #ccc;
}

.add-button {
	background-color: #62c7c2;
	text-align: center;
	padding: 20px 10px;
	width: 100px;
	border: 1px solid #62c7c2;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
	margin: auto;
}

.remove-button {
	background-color: red;
	text-align: center;
	padding: 5px 0;
	border: 1px solid red;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
}

.submit-button {
	margin: auto;
	background-color: #62c7c2;
	text-align: center;
	padding: 20px 0;
	border: 1px solid #62c7c2;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
	width: 100px;
}
</style>
